export default __webpack_public_path__ + "static/media/gnl1.49be5469.jpg";